import type React from 'react'
import ColumnInfoTooltip from 'core/elements/tooltip/ColumnInfoTooltip'

// FR-041: one-line explanation per VM HA Protection Status value, shown as a single
// legend in the column header tooltip (not per-row), mirroring ImageStatusInfo.
const statuses = [
  {
    name: 'VM HA disabled',
    description:
      'VM HA is turned off for this cluster, so this VM will not be restarted on another host if its host fails.',
  },
  {
    name: 'Protected',
    description:
      "If this VM's host fails, VM HA will restart the VM on another host in the cluster.",
  },
  {
    name: 'Not protected',
    description:
      "If this VM's host fails, VM HA will restart it on another host from its base image, and any data on its local ephemeral storage will be lost.",
  },
  {
    name: 'Excluded',
    description:
      "This VM uses ephemeral storage, and this cluster's VM HA settings skip such VMs. It will not be restarted on another host if its host fails.",
  },
]

const VmhaProtectionStatusInfo: React.FC = () => <ColumnInfoTooltip statuses={statuses} />

export default VmhaProtectionStatusInfo
